// extracted by mini-css-extract-plugin
export default {"root":"PublicPasswordDeleteModal__root--Gf880","text":"PublicPasswordDeleteModal__text--2n63d"};